// /Users/adrian.leineweber/Development/gemini-test/client/src/components/BookSearch.js
import React, { useState, useRef, useEffect, useCallback } from 'react'; // useCallback hinzugefügt
import { Box, TextField, InputAdornment, IconButton } from '@mui/material'; // IconButton hinzugefügt
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear'; // ClearIcon hinzugefügt

const BookSearch = React.memo(({ onSearch, searchTerm }) => {
  const [inputValue, setInputValue] = useState(searchTerm);
  const inputRef = useRef(null);
  const debounceTimer = useRef(null);

  // Effekt, um den lokalen State zu aktualisieren, wenn sich der externe searchTerm ändert
  // (z.B. durch Filter-Reset)
  useEffect(() => {
    setInputValue(searchTerm);
  }, [searchTerm]);

  // Handler für die Eingabeänderung (mit Debounce)
  const handleSearchChange = useCallback((e) => {
    const value = e.target.value;
    setInputValue(value);
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      onSearch(value);
    }, 300);
  }, [onSearch]); // Abhängigkeit von onSearch

  // Handler zum Löschen des Suchbegriffs
  const handleClearSearch = useCallback(() => {
    setInputValue('');
    onSearch(''); // Sofort die Suche mit leerem String auslösen
    if (inputRef.current) {
      inputRef.current.focus(); // Optional: Fokus nach dem Löschen wiederherstellen
    }
  }, [onSearch]); // Abhängigkeit von onSearch

  // Effekt zum Fokussieren (bleibt gleich)
  useEffect(() => {
    // Fokus nur setzen, wenn der Suchbegriff initial leer ist,
    // um nicht ständig den Fokus zu stehlen, wenn extern gefiltert wird.
    if (inputRef.current && searchTerm === '') {
      // inputRef.current.focus(); // Optional: Kann störend sein, wenn man woanders klickt
    }
  }, [searchTerm]); // Abhängigkeit von searchTerm

  return (
    <Box display="flex" gap={2} alignItems="center">
      <TextField
        type="text"
        placeholder="Suchen..."
        value={inputValue}
        onChange={handleSearchChange}
        fullWidth
        inputRef={inputRef}
        variant="outlined"
        size="small" // Ziel 1: Kleineres Feld
        sx={{ // Ziel 2: Rundere Optik
          '& .MuiOutlinedInput-root': {
            borderRadius: '20px', // Passen Sie den Wert nach Bedarf an
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          // Ziel 3: Löschen-Button hinzufügen
          endAdornment: (
            <InputAdornment position="end">
              {/* Zeige Button nur, wenn Text vorhanden ist */}
              {inputValue.length > 0 && (
                <IconButton
                  aria-label="Suchfeld leeren"
                  onClick={handleClearSearch}
                  edge="end" // Wichtig für korrekten Abstand
                  size="small" // Passend zur TextField-Größe
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
            </InputAdornment>
          )
        }}
      />
    </Box>
  );
});

export default BookSearch;
